import { render, staticRenderFns } from "./conference_brand.vue?vue&type=template&id=68582a5a&scoped=true&"
import script from "./conference_brand.vue?vue&type=script&lang=js&"
export * from "./conference_brand.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/brand.css?vue&type=style&index=0&id=68582a5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68582a5a",
  null
  
)

export default component.exports